import React from 'react';
import PropTypes from 'prop-types';
import { Price as FinancePrice } from '../../../../../classes/finance/index';

function DealCondition (props) {
  /** @var Announcement */
  const item = props.item;

  const priceInfo = FinancePrice.getPriceInfo(item);
  const dealCondition = item.getDealCondition();
  const rentPeriod = dealCondition.getRentPeriod();

  return (
    <td className='paper col-deal-condition'>
      { priceInfo.utilities && (<div>{priceInfo.utilities}</div>) }
      { priceInfo.deposit && (<div>{priceInfo.deposit}</div>) }

      <div>
        {
          [
            dealCondition.getLabelClearSale(),
            dealCondition.getLabelExchange(),
            dealCondition.getLabelExchangePicked(),
            dealCondition.getLabelExclusive(),
            priceInfo.commission,
            rentPeriod && rentPeriod.get('fullName')
          ].filter(Boolean).join(', ')
        }
      </div>
    </td>
  );
}

DealCondition.propTypes = {
  item: PropTypes.object.isRequired
};

DealCondition.defaultProps = {};

export default DealCondition;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/DealCondition.jsx